import AdminStudentEnquiry from "./AdminStudentEnquiry"

const AdminStudentEnquiryPage = () => {
  return <AdminStudentEnquiry/>
}

export default AdminStudentEnquiryPage